import { MAX_FRAUDULENT_EMAIL_AMOUNT } from 'OpsCenter/app.constants';

export default {
  template: `
  <div class="customer-bulk-delete-component">
    <div class="panel panel-default">
      <div class="panel-heading">Fraudulent customers 
        <p class="m-t-sm text-important">
            These customers won't be allowed to create new reservations, redeem points or receive transactional emails. 
            All future reservations will be marked as MERCHANT CANCELED
        </p>
        <p class="m-t-sm text-important">
            Maximum amount allowed is 90. 
        </p>
      </div>
      <div class="panel-body">
        <div class="col-md-6">
          <textarea class="form-control"
                    data-ng-model="$ctrl.emails"></textarea>
          <p data-ng-if="$ctrl.invalidEmails.length > 0">{{$ctrl.invalidEmails}}</p>
        </div>
        <div>
          <div class="col-md-6">
            <button class="btn btn-danger" 
                    data-ng-click="$ctrl.block()" 
                    data-ng-disabled="!($ctrl.emails && $ctrl.emails.length > 0)">Flag customers as fraudulent</button>  
          </div>
        </div>
      </div>
    </div>
  </div>
  `,
  controller: class {
    constructor($window, fraudulentCustomersService, NotificationService) {
      this.fraudulentCustomersService = fraudulentCustomersService;
      this.notificationService = NotificationService;
      this.emails = '';
      this.window = $window;
      this.invalidEmails = '';
    }

    block() {
      this.invalidEmails = '';

      if (!this.window.confirm('Are you sure you want to flag these customers are fraudulent?')) {
        return;
      }

      const trimEmptySpaces = email => email.trim();
      const removeEmptyStrings = email => email.length > 0;
      const emailsToBlock = this.emails
        .split(',')
        .map(trimEmptySpaces)
        .filter(removeEmptyStrings);

      if (emailsToBlock.length > MAX_FRAUDULENT_EMAIL_AMOUNT) {
        this.notificationService.error('You have entered more than the allowed limit of 90 emails. Please reduce the number of emails and try again.');
        return;
      }

      this.fraudulentCustomersService
        .block(emailsToBlock)
        .then(() => this.notificationService.success('Customers were successfully marked as fraudulent'))
        .catch((error) => {
          if (error.data && error.data.errors[0].message === 'Maximum number must be 90.') {
            this.notificationService.error('You have entered more than the allowed limit of 90 emails. Please reduce the number of emails and try again.');
          } else {
            this.notificationService.error('There was an error performing the operation');
            this.invalidEmails = error.data && error.data.errors[0].message;
          }
        });
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/customers/fraudulent-customers/fraudulent-customers.component.js